import { Grid } from '@mui/material';

import { FBoxContainer } from '../../../../../../../components/baseV2';
import { QuestionnaireSectionLabel } from '../../../../../common';
import PolicyholderAddressFields from './PolicyholderAddressFields';
import PolicyholderIdentityFields from './PolicyholderIdentityFields';

import type { PolicyholderInformationFieldsProps } from './types';

export default function PolicyholderInformationFields({
  formik,
  disabled,
  saveFieldOnBlur,
  handleSameAsMemberChange,
  handleAddressFieldChange,
  saveAddressFieldOnChange,
}: PolicyholderInformationFieldsProps) {
  return (
    <FBoxContainer>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <QuestionnaireSectionLabel variant="h6">
            Policyholder Information
          </QuestionnaireSectionLabel>
        </Grid>
        <PolicyholderIdentityFields
          disabled={disabled}
          formik={formik}
          handleSameAsMemberChange={handleSameAsMemberChange}
          saveFieldOnBlur={saveFieldOnBlur}
        />
        <PolicyholderAddressFields
          disabled={disabled}
          formik={formik}
          handleAddressFieldChange={handleAddressFieldChange}
          saveAddressFieldOnChange={saveAddressFieldOnChange}
          saveFieldOnBlur={saveFieldOnBlur}
        />
      </Grid>
    </FBoxContainer>
  );
}
